// extracted by mini-css-extract-plugin
export default {"container":"NmiGooglePayButton_container__GvL3K","buttonWrapper":"NmiGooglePayButton_buttonWrapper__geTuT"};